module.exports = "<div class=\"protected\">\n  <div class=\"codeitems\">\n    <div class=\"codeitem\">\n      <span class=\"icon\" [ngClass]=\"codeitem | icon\"></span>\n      <span class=\"display\">{{codeitem.display}}</span>\n    </div>\n  </div>\n  <div class=\"trailing tooltip\">\n    <i class=\"icon lock\"></i>\n    <span class=\"tooltiptext\">This automation was created by your Control4 dealer and cannot be modified here. Please contact your Control4 dealer for more information.</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/protected-programming/protected-programming.component.html
// module id = 1537
// module chunks = 2